<template>
  <div class="my_form">
      <el-form :model="form"  ref="form" inline  label-width="80px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="主  题:" prop="title">
              <el-input placeholder="请输入邮件主题"  v-model="form.title" />
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="num === 2 || num === 1">
            <el-form-item label="发件人:">
              <el-input disabled v-model="form.senderName" />
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="num === 2 || num === 1">
            <el-form-item label="抄送人:">
              <el-input disabled v-model="form.copyUserNames" />
            </el-form-item>
          </el-col>
          <el-col :span="24"  v-if="num !== 1 && num !== 2">
            <el-form-item label="收件人:" prop="receivers">
                <el-select :disabled="num !== 5 && num !== 0 && num !== 3" placeholder="请选择收件人" v-model="form.receivers" multiple filterable :filter-method="handleFilter" @visible-change="options = [...userList]">
                  <el-option-group
                    v-for="group in options"
                    :key="group.label"
                    :label="group.label">
                    <el-option
                      v-for="item in group.options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-option-group>
                </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="num !== 1 && num !== 2">
            <el-form-item label="抄送人:" prop="copyUsers">
                <el-select :disabled="num !== 5 && num !== 0 && num !== 3" placeholder="请选择抄送人" v-model="form.copyUsers" multiple filterable :filter-method="handleFilter" @visible-change="options = [...userList]">
                  <el-option-group
                    v-for="group in options"
                    :key="group.label"
                    :label="group.label">
                    <el-option
                      v-for="item in group.options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-option-group>
                </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="num !== 0 && form.oaEmailFileVoList.length">
            <el-form-item label="附件:" prop="file">
              <div v-for="item in form.oaEmailFileVoList" :key="item.filename">
                <a href="javascript:;" @click="handleDownload(item)">{{item.fileName}}</a>
              </div>
            </el-form-item>
          </el-col>
          <el-col v-if="num=== 0 || num === 5 || num === 3" :span="24" style="margin-bottom: 10px;">
            <!-- <el-form-item label=" " prop="file"> -->
              <el-upload
                style="display:inline-block;"
                ref="upload"
                :action="baseUrl"
                :headers="headers"
                method="post"
                :data='fileData'
                name="uploadFile"
                :on-success="handleSuccess"
                :on-error="handleError"
                :before-upload='handleBeforeUpload'
                :on-remove="handleRemove">
                <div style="margin-top: 3px;display:flex;align-items:center">
                  <img width="15" src="@/assets/img/file.png" alt="">
                  <span style="margin-left: 5px;">添加附件(最大2M)</span>
                </div>
              </el-upload>
          </el-col>
          <el-col :span="24">
            <el-form-item label="" prop="content">
              <WangEditor ref="content" :key="num !== 0 && num !== 5 && num !== 3" :disabled="num !== 0 && num !== 5 && num !== 3" v-model="form.content" @change="handleChange"/>
              <WangEditor class="history" ref="history" v-if="form.history" :disabled="true" v-model="form.history"/>
            </el-form-item>
              <!-- <el-input
                :class="{textareaOne:!!form.history}"
                type="textarea"
                :rows="15"
                :disabled="num !== 0 && num !== 5 && num !== 3"
                placeholder="请输入内容"
                v-model="form.content">
              </el-input> -->
              <!-- <el-input
                v-if="form.history"
                class="textareaTwo"
                type="textarea"
                :rows="15"
                disabled
                placeholder="请输入内容"
                v-model="form.history">
              </el-input> -->
          </el-col>
          <el-col :span="24" v-if="num === 0 || num === 5" class="footer">
             <el-button type="primary" @click="handleSubmit(0)">发送</el-button>
            <el-button type="success" @click="handleSubmit(1)">保存草稿</el-button>
            <el-button @click="handleClose">关闭</el-button>
          </el-col>
          
          <el-col :span="24" v-if="num === 1" class="footer">
             <el-button type="primary" @click="handleReply('RE')">回复</el-button>
            <el-button type="success" @click="handleReply('FW')">转发</el-button>
            <el-button @click="$emit('update:visible', true)">关闭</el-button>
          </el-col>
          <el-col :span="24" v-if="num === 2" class="footer">
            <el-button type="success" @click="handleReply('FW')">转发</el-button>
             <el-button type="primary" @click="handleDelete" :loading="loading">删除</el-button>
            <el-button @click="$emit('update:visible', true)">关闭</el-button>
          </el-col>
          <el-col :span="24" v-if="num === 3" class="footer">
            <el-button type="success" @click="handleSubmit(0)">发送</el-button>
             <el-button type="primary" @click="handleDelete" :loading="loading">删除</el-button>
            <el-button @click="$emit('update:visible', true)">关闭</el-button>
          </el-col>
          <el-col :span="24" v-if="num === 4" class="footer">
            <el-button type="success" @click="handleRestore">恢复</el-button>
             <el-button type="primary" @click="handleDelete" :loading="loading">删除</el-button>
            <el-button @click="$emit('update:visible', true)">关闭</el-button>
          </el-col>
        </el-row>
      </el-form>
  </div>
</template>

<script>
import { Email } from '@/api/email'
import { LicenseManagement } from '@/api/Licence'
import projectConfig from '@/core/config'
import WangEditor from '@/components/Editor/WangEditor.vue'
export default {
  props: {
    record: {
      type: Object,
      default: () => {}
    },
    type:{
      type:Number,
      default: 0
    },
    visible:{
      type:Boolean,
      default: true
    }
  },
  components:{
    WangEditor
  },
  data () {
    return {
      form: {
        copyUsers: [],
        title: '',
        receivers: [],
        content:'',
        history: ''
      },
      baseUrl: projectConfig.baseUrl + 'admin/online/onlineOperation/uploadDatasource/oaEmailFile',
      token: localStorage.getItem('token'),
      headers: null,
      fileData: {
        asImage: false,
        fieldName: 'file_name',
        datasourceId:  '1697212133265117185'
      },
      options:[],
      userList: [],
      num: 0,
      fileList: [],
      sendType: 'NORMAL',
      loading: false
    };
  },
  watch: {
    type:{
      deep : true,
      immediate:true,
      handler(type){
        // 0-写邮件  1-收件箱  2-已发送 3-草稿箱 4-废纸篓
        this.num = type
        this.loading = false
      }
    },
    record:{
      deep : true,
      immediate:true,
      handler(data){
        if(!data) return
        this.fileList = this.form.oaEmailFileVoList || []
        this.sendType = data.sendType
        if(this.type === 1 && data.checkFlag === 1) this.handerRead(data.receiveId)
        this.form = {
          ...data,
          receivers: data.receivers ? data.receivers.split(',').map(item => item) : '',
          copyUsers: data.copyUsers ? data.copyUsers.split(',').map(item => item) : '',
          history:''
        }
        if(data.relateEmailList) {
          data.relateEmailList.forEach(item => {
const html = `
--------------原始邮件--------------
发件人: ${item.senderName}
发送时间: ${item.sendTime}
收件人: ${item.receiverNames}
主题: ${item.title}
--------------邮件正文--------------
`
            this.form.history += html + item.content
          })
          
          this.$nextTick(() => {
            this.$refs.history.setInnerHtml(this.form.history)
          })
        }
        this.$nextTick(() => {
          this.$refs.content.setInnerHtml(this.form.content)
        })
      }
    }
  },
  created () {
    this.getDeptAndPeople()
    this.headers = {
      Authorization: this.token
    }
  },
  methods: {
    handleChange(val){
      this.form.content = val
    },
    handerRead(receiveId){
      Email.read(this,{receiveId}).then(res => {
        this.$emit('reset',false)
      })
    },
    // 抄送人&&收件人数据处理
    getDeptAndPeople () {
      Promise.all([
        LicenseManagement.getDeptList(this, {}),
        LicenseManagement.getPeopleList(this, {}),
        Email.recentContacts(this, {})
      ]).then(res => {
        let arr = []
        res[0].data.dataList.forEach(item => {
          if(item.deptId !== '1440911410581213416' && item.deptId !== '1440963733084966913'){
            arr.push({
              label: item.deptName,
              deptId: item.deptId,
              options: []
            })
          }
        });
        arr.forEach(item => {
          res[1].data.dataList.forEach(data => {
            if(data.deptId === item.deptId){
              item.options.push({
                label:data.showName,
                value: data.userId.toString()
              })
            }
          })
        })
        arr.unshift({
          label: '最近联系人',
          options : res[2].data.map(item => {
            return {
              label:item.showName,
              value: item.userId.toString()
            }
          })
        })
        this.userList = arr
        this.options = arr
      })
    },
    handleFilter(val){
      if(val){
        this.options = []
        this.userList.forEach(item => {
          if(item.label.indexOf(val) > -1) {
            this.options.push(item)
          } else {
            let arr = []
            item.options.forEach(data => {
              if(data.label.indexOf(val) > -1){
                arr.push(data)
              }
            })
            if(arr.length){
              this.options.push({
                ...item,
                options: arr
              })
            }
          }
        })
      }else {
        this.options = [...this.userList]
      }
    },
    // 转发/回复
    handleReply(type){
      this.form.history = ''
      let html = `
      --------------原始邮件--------------
      发件人: ${this.form.senderName}
      发送时间: ${this.form.sendTime}
      收件人: ${this.form.receiverNames}
      主题: ${this.form.title}
      --------------邮件正文--------------
      `
      this.form.history = html + this.form.content
      if(this.form.relateEmailList) {
        this.form.relateEmailList.forEach(item => {
          html = `
          --------------原始邮件--------------
          发件人: ${this.form.senderName}
          发送时间: ${this.form.sendTime}
          收件人: ${this.form.receiverNames}
          主题: ${item.title}
          --------------邮件正文--------------
          `
          this.form.history += html + item.content
        })
      }
      this.form.content = ''
      this.sendType = type
      // if(this.form.title.indexOf(type) === -1) 
      this.form.title = type + ': ' + this.form.title
      // 展示按钮变为 写邮件按钮
      this.num = 5
      if (type === 'RE') {
        this.form.oaEmailFileVoList = []
      }
      if (type === 'FW') {
        this.form.receivers = []
      } else {
        this.form.receivers = this.type === 1 ? [this.form.sender.toString()] : []
      }
      
      this.$nextTick(() => {
        this.$refs.content.setInnerHtml(' ')
        this.$refs.history.setInnerHtml(this.form.history)
      })
      this.form.copyUsers = []
    },
    // 发送
    handleSubmit(num){
      const str = this.verification()
      if(str){
        this.prompt('error', str) 
        return
      }
      const oaEmailDto = {
        ...this.form,
        copyUsers: this.form.copyUsers.join(','),
        receivers: this.form.receivers.join(','),
        sendType: this.sendType,
        oaEmailFileDtoList: this.form.oaEmailFileVoList&&this.form.oaEmailFileVoList.length ? this.fileList.concat(this.form.oaEmailFileVoList.map(item => {
          if(this.type == 3){
            return item
          } else {
            return {
              fileName: item.fileName,
              originalName: item.originalName
            }
          }
        })) : this.fileList,
        id:this.type === 3 ? this.form.id : null,
        relateId: this.sendType !== 'NORMAL' ? this.type == 3 ? this.record.relateId : this.record.id : null
      }
      if(this.type !== 3) delete oaEmailDto.id
      const api = num ? Email.saveDraft : Email.sendEmail
      api(this,{oaEmailDto}).then(res => {
        this.prompt('success', num ? '已保存至草稿箱!' : '发送成功!')
        this.$emit('reset',false)
        this.reset(false)
        if(!this.visible) {
          this.$emit('update:visible', true)
        }
      })
    },
    // 关闭
    handleClose(){
       this.$confirm('是否保存草稿箱?', '提示', {
          confirmButtonText: '保存',
          cancelButtonText: '不保存',
          type: 'warning'
        }).then(() => {
          this.handleSubmit(1)
        }).catch(() => {
          this.reset()      
        }).finally(() => {
          if(!this.visible) {
            this.$emit('update:visible', true)
          }
        });
    },
    // 删除至废纸篓
    handleDelete(){
        this.$confirm('是否确定删除!', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const oaEmailOperateDto = {
            emailType: this.type,
            ids:[this.form.id]
          }
          const deleteList = [
            {
              id: this.form.emailType === 1 ? this.form.receiveId : this.form.id,
              emailType: this.form.emailType
            }
          ]
          this.loading = true
          const api = this.type === 4 ? Email.deleteWaste(this,{deleteList}) : Email.putWaste(this,{oaEmailOperateDto})
          api.then(res => {
            this.prompt('success',this.type === 4 ? '已删除':'已删除至废纸篓') 
            if(!this.visible) {
              this.$emit('update:visible', true)
            }
            this.$emit('reset',false)
          }).finally(() => {
            this.loading = false
          })
        }).catch(() => {
          this.prompt('info','已取消删除操作')          
        });
    },
    // 废纸篓-恢复操作
    handleRestore(){
      this.$confirm('是否确定恢复!', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Email.restore(this,{
          oaEmailOperateDto: {
            emailType: this.form.emailType,
            ids: this.form.emailType === 1 ? [this.form.receiveId] : [this.form.id ]
          }
        }).then(res => {
          const arr = ['','收件箱', '已发送', '草稿箱']
          this.prompt('success','已恢复至' + arr[this.form.emailType])  
          this.$emit('reset',false)
          if(!this.visible) {
            this.$emit('update:visible', true)
          }
        })
      }).catch(() => {
        this.prompt('info','已取消恢复操作')        
      });
    },
    //提示
    prompt(type,message){
      this.$message({
        type,
        message
      });
    },
    // 重置表单
    reset(bool){
      if(bool) this.prompt('info','已清空内容')  
      if(this.$refs.upload)this.$refs.upload.clearFiles()
      this.form={
        copyUsers: [],
        title: '',
        receivers: [],
        content:'',
        history: ''
      }  
    },
    // 字段校验
    verification(){
      let str = ''
      if(!this.form.title){
        str = '请输入邮件主题'
      } else if(!this.form.receivers.length){
        str = '请选择收件人'
      } else if(!this.form.content){
        str = '请输入内容'
      }
      return str
    },
    // 附件上传
    handleSuccess(res,file) {
      res.data.originalName = file.name
      this.fileList.push(res.data)
    },
    // 移除附件
    handleRemove(res,file){
      if(file.length){
        this.fileList = file.map(item => item.response.data)
      } else {
        this.fileList = []
      }
    },
    // 上传失败
    handleError() {
      this.$message.error('上传失败');
    },
    // 文件大小校验
    handleBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 <= 2 // 图片限制大小20M
      if (!isLt2M) {
        this.prompt('info','图片大小不能超过2M')  
      }
      return new Promise((resolve, reject) => {
        if (!isLt2M) {
          reject(new Error(''))
        } else {
          resolve(true)
        }
      })
    },
    // 下载附件
    handleDownload (record) {
      const url = projectConfig.baseUrl + 'admin/online/onlineOperation/downloadDatasource/oaEmailFile?datasourceId=1697212133265117185&fieldName=file_name&asImage=false&dataId=' + record.id + '&filename=' + record.fileName + '&Authorization=' + this.token + '&MenuId=1631159779164426240'
      this.downloadFile2(url, record.fileName)
    }
  }
};
</script>
<style lang="scss" scoped>
.footer{
  text-align: right !important;
  margin-top: 20px !important;
}
::v-deep(.el-select__tags){
  flex-wrap: nowrap;
  overflow: auto;
  // text-overflow: ellipsis;
}
::v-deep(.el-textarea){
  .el-textarea__inner{
    background-color: #fff !important;
    color: #000 !important;
  }
 .is-disabled{
 }
}
.textareaOne{
  ::v-deep(.el-textarea__inner){
    border-bottom: 1px solid #ffffff !important;
  }
}
.textareaTwo{
  ::v-deep(.el-textarea__inner){
    border-top: 1px solid #ffffff !important;
  }
}
</style>